import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    container: {
        fontSize: 12,
        marginBottom: "20px"
    },
    identifierContainer: {
        flexDirection: 'row',
        justifyContent: 'flex',
    },
    dateContainer: {
        flexDirection: 'row',
        justifyContent: 'flex',
    },
    date: {

        fontStyle: 'bold',
    },
    label: {
        width: 110
    }

});


const Identifiers = ({ identifier, date }) => (
    <Fragment >
        <View style={styles.container}>
            <View style={styles.identifierContainer}>
                <Text style={styles.label}>{identifier ? "Identificador: " : ""}</Text>
                <Text style={styles.ate}>{identifier}</Text>
            </View >
            <View style={styles.dateContainer}>
                <Text style={styles.label}>Fecha de descarga: </Text>
                <Text > {date}</Text>
            </View >
        </View>
    </Fragment>
);

export default Identifiers